module.exports = __webpack_public_path__ + "img/coin.06f89bf7.png";